import React from "react";
import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
const FullPageLoader: React.FC = () => {
  const loading = useSelector((state: RootState) => state.loader.loading);

  if (!loading) return null;

  return (
    <div className="loader-div">
      <div className="loadingio-spinner-ripple-5xrpd0k7ecq">
        <div className="ldio-9uukc0wm668">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default FullPageLoader;